import script from "./ServiceCategoryListSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCategoryListSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ServiceCategoryListSkeleton.vue?vue&type=style&index=0&id=6473859e&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6473859e"]])

export default __exports__